import React from 'react';
import { motion } from 'framer-motion';
import { 
  Download as DownloadIcon, 
  Smartphone, 
  Shield, 
  Zap, 
  Star, 
  CheckCircle,
  Users,
  Trophy,
  Gamepad2,
  Gift,
  Sparkles,
  Lock,
  RefreshCw
} from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Download = () => {
  const [showComingSoon, setShowComingSoon] = React.useState(false);

  const features = [
    {
      icon: <Trophy className="w-6 h-6 text-[#00fff5]" />,
      title: 'Win Real Cash',
      desc: 'Compete in skill-based tournaments and win real money'
    },
    {
      icon: <Zap className="w-6 h-6 text-[#00fff5]" />,
      title: 'Instant Withdrawals',
      desc: 'Withdraw your winnings directly to UPI'
    },
    {
      icon: <Shield className="w-6 h-6 text-[#00fff5]" />,
      title: 'Secure & Fair',
      desc: 'Advanced anti-cheat system for fair play'
    },
    {
      icon: <Users className="w-6 h-6 text-[#00fff5]" />,
      title: 'Active Community',
      desc: '50,000+ players competing daily'
    },
    {
      icon: <Gamepad2 className="w-6 h-6 text-[#00fff5]" />,
      title: 'BGMI & Free Fire',
      desc: 'Tournaments for both popular games'
    },
    {
      icon: <Gift className="w-6 h-6 text-[#00fff5]" />,
      title: 'Welcome Bonus',
      desc: 'Get 50 free coins on first download'
    }
  ];

  const steps = [
    {
      number: '01',
      title: 'Download App',
      desc: 'Click the download button below to get the APK'
    },
    {
      number: '02',
      title: 'Install APK',
      desc: 'Allow installation from unknown sources in settings'
    },
    {
      number: '03',
      title: 'Create Account',
      desc: 'Sign up with your email or phone number'
    },
    {
      number: '04',
      title: 'Start Winning',
      desc: 'Join tournaments and withdraw your winnings'
    }
  ];

  const stats = [
    { value: '2K+', label: 'Downloads', icon: DownloadIcon },
    { value: '4.5', label: 'App Rating', icon: Star },
    { value: '1K+', label: 'Daily Active', icon: Users },
    { value: '₹5k+', label: 'Prize Money', icon: Trophy },
  ];

  const reviews = [
    {
      name: 'Rahul S.',
      rating: 5,
      text: 'Best platform for BGMI tournaments. Withdrawals are super fast!',
      game: 'BGMI'
    },
    {
      name: 'Priya K.',
      rating: 5,
      text: 'Fair play and great community. Won ₹5000 last week!',
      game: 'Free Fire'
    },
    {
      name: 'Akash M.',
      rating: 5,
      text: 'Legit platform with actual withdrawals. Highly recommend!',
      game: 'BGMI'
    }
  ];

  const faqs = [
    {
      q: 'Is the app free to download?',
      a: 'Yes, TheArenaX is completely free to download and install.'
    },
    {
      q: 'Is it safe to install APK?',
      a: 'Absolutely! Our APK is verified and scanned for malware. We recommend downloading only from our official website.'
    },
    {
      q: 'Which games are supported?',
      a: 'Currently we support BGMI and Free Fire tournaments with more games coming soon.'
    },
    {
      q: 'How do I withdraw my winnings?',
      a: 'Go to Wallet → Redeem, enter your UPI ID and amount. Withdrawals are processed within 24-48 hours.'
    }
  ];

  // Coming Soon handler
  const handleComingSoon = () => {
    setShowComingSoon(true);
  };

  return (
    <div className="min-h-screen bg-[#0A0F1E]">
      <Navbar />
      
      {/* Hero Section with Animated Background */}
      <section className="relative pt-32 pb-20 px-4 overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-20 left-10 w-96 h-96 bg-[#00fff5] rounded-full filter blur-3xl opacity-10"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#7000ff] rounded-full filter blur-3xl opacity-10"></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] border border-[#00fff5] rounded-full opacity-5 animate-pulse"></div>
        </div>
        
        <div className="max-w-7xl mx-auto relative z-10">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
            >
              <div className="inline-block px-4 py-2 bg-[#00fff520] border border-[#00fff5] rounded-full mb-6">
                <span className="text-[#00fff5] font-rajdhani font-bold text-sm">VERSION 2.0.0</span>
              </div>
              <h1 className="text-5xl md:text-6xl font-rajdhani font-bold text-white mb-6">
                Download The<span className="text-[#00fff5]">Arena</span>X App
              </h1>
              <p className="text-xl text-gray-400 font-rajdhani mb-8">
                Join India's fastest growing skill-based gaming platform. Compete in BGMI and Free Fire 
                tournaments, win real cash prizes, and withdraw instantly to your UPI account.
              </p>
              
              {/* Download Buttons - Updated to show Coming Soon */}
              <div className="flex flex-col sm:flex-row gap-4 mb-8">
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={handleComingSoon}
                  className="bg-gradient-to-r from-[#00fff5] to-[#7000ff] px-8 py-5 rounded-xl text-white font-rajdhani font-bold text-lg flex items-center justify-center gap-3 hover:opacity-90 transition group relative overflow-hidden cursor-pointer"
                >
                  <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-20 transition"></div>
                  <DownloadIcon className="w-6 h-6" />
                  <span>Download APK (Coming Soon)</span>
                </motion.button>
                
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="bg-[#1E2338] border border-[#2A2F45] px-8 py-5 rounded-xl text-white font-rajdhani font-bold text-lg flex items-center justify-center gap-3 hover:bg-[#2A2F45] transition cursor-not-allowed opacity-75"
                  disabled
                >
                  <Smartphone className="w-6 h-6" />
                  <span>iOS (Coming Soon)</span>
                </motion.button>
              </div>

              {/* Version Info */}
              <div className="flex flex-wrap gap-6 text-sm">
                <div className="flex items-center gap-2 text-gray-400">
                  <CheckCircle className="w-4 h-4 text-[#00E676]" />
                  <span>Version 2.0.0</span>
                </div>
                <div className="flex items-center gap-2 text-gray-400">
                  <RefreshCw className="w-4 h-4 text-[#00E676]" />
                  <span>Updated March 2026</span>
                </div>
                <div className="flex items-center gap-2 text-gray-400">
                  <Lock className="w-4 h-4 text-[#00E676]" />
                  <span>Secure & Verified</span>
                </div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="relative"
            >
              <div className="bg-gradient-to-r from-[#00fff5] to-[#7000ff] p-1 rounded-3xl">
                <div className="bg-[#0A0F1E] rounded-3xl p-8">
                  {/* QR Code Placeholder */}
                  <div className="bg-white p-4 rounded-2xl inline-block mb-6 mx-auto block w-fit">
                    <div className="grid grid-cols-7 gap-1">
                      {[...Array(49)].map((_, i) => (
                        <div key={i} className={`w-2 h-2 ${Math.random() > 0.5 ? 'bg-black' : 'bg-gray-300'}`}></div>
                      ))}
                    </div>
                  </div>
                  <p className="text-white font-rajdhani text-center mb-2">Coming Soon</p>
                  <p className="text-gray-400 text-sm text-center">APK will be available shortly</p>
                </div>
              </div>
              
              {/* Floating Elements */}
              <motion.div
                animate={{ y: [0, -10, 0] }}
                transition={{ duration: 3, repeat: Infinity }}
                className="absolute -top-4 -right-4 bg-gradient-to-r from-[#FFD700] to-[#FFA500] rounded-full p-3"
              >
                <Sparkles className="w-6 h-6 text-black" />
              </motion.div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {stats.map((stat, index) => {
              const IconComponent = stat.icon;
              return (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="bg-gradient-to-b from-[#1E2338] to-[#14182B] border border-[#2A2F45] rounded-2xl p-6 text-center group hover:border-[#00fff5] transition"
                >
                  <div className="inline-block p-3 bg-[#00fff510] rounded-xl mb-3 group-hover:bg-[#00fff520] transition">
                    <IconComponent className="w-8 h-8 text-[#00fff5]" />
                  </div>
                  <div className="text-3xl md:text-4xl font-rajdhani font-bold text-white mb-2">{stat.value}</div>
                  <div className="text-gray-400 font-rajdhani">{stat.label}</div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Features Grid */}
      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <div className="inline-block p-3 bg-[#00fff510] rounded-xl mb-4">
              <Zap className="w-8 h-8 text-[#00fff5]" />
            </div>
            <h2 className="text-4xl md:text-5xl font-rajdhani font-bold text-white mb-4">
              Why <span className="text-[#00fff5]">Download</span> TheArenaX
            </h2>
            <p className="text-xl text-gray-400 font-rajdhani max-w-3xl mx-auto">
              Everything you need to start your esports journey
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-gradient-to-b from-[#1E2338] to-[#14182B] border border-[#2A2F45] rounded-2xl p-6 group hover:border-[#00fff5] transition"
              >
                <div className="inline-block p-3 bg-[#00fff510] rounded-xl mb-4 group-hover:bg-[#00fff520] transition">
                  {feature.icon}
                </div>
                <h3 className="text-xl font-rajdhani font-bold text-white mb-2">{feature.title}</h3>
                <p className="text-gray-400 font-rajdhani">{feature.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* How to Install Section */}
      <section className="py-20 px-4 bg-[#0A0F1E]">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
            >
              <div className="inline-block px-4 py-2 bg-[#00fff520] border border-[#00fff5] rounded-full mb-6">
                <span className="text-[#00fff5] font-rajdhani font-bold text-sm">EASY SETUP</span>
              </div>
              <h2 className="text-4xl md:text-5xl font-rajdhani font-bold text-white mb-6">
                Install in <span className="text-[#00fff5]">4 Simple Steps</span>
              </h2>
              <p className="text-gray-400 font-rajdhani text-lg mb-8">
                Getting started with TheArenaX is quick and easy. Follow these steps to join the action.
              </p>

              <div className="space-y-4">
                {steps.map((step, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                    className="flex items-start gap-4"
                  >
                    <div className="w-12 h-12 bg-gradient-to-r from-[#00fff5] to-[#7000ff] rounded-xl flex items-center justify-center font-rajdhani font-bold text-white">
                      {step.number}
                    </div>
                    <div>
                      <h3 className="text-white font-rajdhani font-bold text-lg">{step.title}</h3>
                      <p className="text-gray-400 font-rajdhani">{step.desc}</p>
                    </div>
                  </motion.div>
                ))}
              </div>

              {/* Installation Tips */}
              <div className="mt-8 bg-[#1E2338] border border-[#2A2F45] rounded-xl p-4">
                <p className="text-[#00fff5] font-rajdhani font-bold mb-2">💡 Pro Tip:</p>
                <p className="text-gray-400 text-sm">
                  If you see "Install blocked" message, go to Settings → Security → Enable "Install from Unknown Sources"
                </p>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              className="relative"
            >
              <div className="bg-gradient-to-r from-[#00fff5] to-[#7000ff] p-1 rounded-3xl">
                <div className="bg-[#0A0F1E] rounded-3xl p-8">
                  <div className="space-y-4">
                    {[
                      'No hidden fees or charges',
                      'One-time download, lifetime access',
                      'Regular updates with new features',
                      '24/7 customer support',
                      'Active community of 50,000+ players',
                      'Weekly tournaments with big prizes',
                    ].map((item, index) => (
                      <div key={index} className="flex items-center gap-3">
                        <CheckCircle className="w-5 h-5 text-[#00E676]" />
                        <span className="text-white font-rajdhani">{item}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* System Requirements */}
      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="text-4xl md:text-5xl font-rajdhani font-bold text-white mb-4">
              System <span className="text-[#00fff5]">Requirements</span>
            </h2>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-6">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              className="bg-gradient-to-b from-[#1E2338] to-[#14182B] border border-[#2A2F45] rounded-2xl p-8"
            >
              <h3 className="text-2xl font-rajdhani font-bold text-white mb-6 flex items-center gap-2">
                <Smartphone className="w-6 h-6 text-[#00fff5]" />
                Android
              </h3>
              <ul className="space-y-4">
                <li className="flex justify-between">
                  <span className="text-gray-400">OS Version</span>
                  <span className="text-white font-rajdhani font-bold">Android 8.0+</span>
                </li>
                <li className="flex justify-between">
                  <span className="text-gray-400">RAM</span>
                  <span className="text-white font-rajdhani font-bold">3GB+</span>
                </li>
                <li className="flex justify-between">
                  <span className="text-gray-400">Storage</span>
                  <span className="text-white font-rajdhani font-bold">100MB free</span>
                </li>
                <li className="flex justify-between">
                  <span className="text-gray-400">Processor</span>
                  <span className="text-white font-rajdhani font-bold">Octa-core 1.8GHz+</span>
                </li>
              </ul>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              className="bg-gradient-to-b from-[#1E2338] to-[#14182B] border border-[#2A2F45] rounded-2xl p-8 opacity-75"
            >
              <h3 className="text-2xl font-rajdhani font-bold text-white mb-6 flex items-center gap-2">
                <Smartphone className="w-6 h-6 text-[#00fff5]" />
                iOS
              </h3>
              <div className="bg-[#00fff510] border border-[#00fff5] rounded-xl p-4 text-center">
                <p className="text-[#00fff5] font-rajdhani font-bold">Coming Soon!</p>
                <p className="text-gray-400 text-sm mt-2">iOS version is under development</p>
              </div>
              <ul className="space-y-4 mt-6 opacity-50">
                <li className="flex justify-between">
                  <span className="text-gray-400">OS Version</span>
                  <span className="text-white font-rajdhani font-bold">iOS 14+</span>
                </li>
                <li className="flex justify-between">
                  <span className="text-gray-400">RAM</span>
                  <span className="text-white font-rajdhani font-bold">3GB+</span>
                </li>
                <li className="flex justify-between">
                  <span className="text-gray-400">Storage</span>
                  <span className="text-white font-rajdhani font-bold">150MB free</span>
                </li>
              </ul>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Reviews Section */}
      <section className="py-20 px-4 bg-[#0A0F1E]">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <div className="inline-block p-3 bg-[#00fff510] rounded-xl mb-4">
              <Star className="w-8 h-8 text-[#FFD700] fill-current" />
            </div>
            <h2 className="text-4xl md:text-5xl font-rajdhani font-bold text-white mb-4">
              What Players <span className="text-[#00fff5]">Say</span>
            </h2>
          </motion.div>

          <div className="grid md:grid-cols-3 gap-6">
            {reviews.map((review, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-gradient-to-b from-[#1E2338] to-[#14182B] border border-[#2A2F45] rounded-2xl p-6"
              >
                <div className="flex items-center gap-1 mb-3">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className={`w-4 h-4 ${i < review.rating ? 'text-[#FFD700] fill-current' : 'text-gray-600'}`} />
                  ))}
                </div>
                <p className="text-white font-rajdhani mb-4">"{review.text}"</p>
                <div className="flex items-center justify-between">
                  <span className="text-gray-400 font-rajdhani">{review.name}</span>
                  <span className="text-[#00fff5] font-rajdhani text-sm">{review.game}</span>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 px-4">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="text-4xl md:text-5xl font-rajdhani font-bold text-white mb-4">
              Frequently Asked <span className="text-[#00fff5]">Questions</span>
            </h2>
          </motion.div>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-[#1E2338] border border-[#2A2F45] rounded-xl p-6"
              >
                <h3 className="text-white font-rajdhani font-bold text-lg mb-2">{faq.q}</h3>
                <p className="text-gray-400 font-rajdhani">{faq.a}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Download CTA */}
      <section className="py-20 px-4">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="bg-gradient-to-r from-[#00fff510] to-[#7000ff10] border border-[#2A2F45] rounded-3xl p-12 text-center"
          >
            <h2 className="text-4xl md:text-5xl font-rajdhani font-bold text-white mb-4">
              Ready to Start <span className="text-[#00fff5]">Winning</span>?
            </h2>
            <p className="text-xl text-gray-400 font-rajdhani mb-8">
              Join 50,000+ players already winning on TheArenaX
            </p>
            
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={handleComingSoon}
              className="bg-gradient-to-r from-[#00fff5] to-[#7000ff] px-12 py-6 rounded-xl text-white font-rajdhani font-bold text-xl flex items-center justify-center gap-3 mx-auto hover:opacity-90 transition group"
            >
              <DownloadIcon className="w-7 h-7 group-hover:animate-bounce" />
              Download TheArenaX Now
            </motion.button>
            
            <p className="text-gray-500 mt-4 text-sm">
              Coming Soon • Version 2.0.0 • Updated March 2026
            </p>
          </motion.div>
        </div>
      </section>

      {/* Coming Soon Modal */}
      {showComingSoon && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <motion.div 
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.3 }}
            className="bg-[#1E2338] border border-[#2A2F45] rounded-3xl p-8 max-w-md w-full text-center relative overflow-hidden"
          >
            {/* Background glow */}
            <div className="absolute -top-20 -left-20 w-60 h-60 bg-[#00fff5] rounded-full filter blur-3xl opacity-10"></div>
            <div className="absolute -bottom-20 -right-20 w-60 h-60 bg-[#7000ff] rounded-full filter blur-3xl opacity-10"></div>
            
            <div className="relative z-10">
              <div className="inline-block p-4 bg-[#00fff510] rounded-full mb-4">
                <Sparkles className="w-12 h-12 text-[#00fff5]" />
              </div>
              
              <h3 className="text-2xl font-rajdhani font-bold text-white mb-2">
                Coming Soon!
              </h3>
              <p className="text-gray-400 font-rajdhani mb-3">
                We're working on something amazing! The APK will be available shortly.
              </p>
              <div className="flex items-center justify-center gap-2 mb-6">
                <div className="w-2 h-2 bg-[#00fff5] rounded-full animate-pulse"></div>
                <div className="w-2 h-2 bg-[#00fff5] rounded-full animate-pulse delay-75"></div>
                <div className="w-2 h-2 bg-[#00fff5] rounded-full animate-pulse delay-150"></div>
              </div>
              <button
                onClick={() => setShowComingSoon(false)}
                className="bg-gradient-to-r from-[#00fff5] to-[#7000ff] px-8 py-3 rounded-xl text-white font-rajdhani font-bold hover:opacity-90 transition w-full"
              >
                Got it
              </button>
            </div>
          </motion.div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Download;